
export function getPixelDistance(map, coord1, coord2) {
    // Convert geographical coordinates to pixel coordinates
    var pixelCoord1 = map.project(coord1);
    var pixelCoord2 = map.project(coord2);

    // Calculate the distance in pixels between the two coordinates
    var dx = pixelCoord2.x - pixelCoord1.x;
    var dy = pixelCoord2.y - pixelCoord1.y;
    var distance = Math.sqrt(dx*dx + dy*dy);

    return distance;
}
